/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Popper = require('popper.js');

window.$ = window.jQuery = require('jquery');

require('admin-lte');
require("bootstrap");

window.Vue = require("vue");

import Vue from "vue";

import axios from "axios";

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

import money from "v-money";
Vue.use(money, { precision: 4 });

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import Inputmask from "inputmask";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component("content-header", require("./cms/ContentHeader.vue").default);
Vue.component("data-table", require("./cms/DataTable.vue").default);
Vue.component("data-table-users", require("./cms/DataTableUsers.vue").default);
Vue.component("tabs", require("./cms/Tabs.vue").default);
Vue.component("ui-form", require("./cms/UIForm.vue").default);
Vue.component("file-upload", require("./cms/FileUpload.vue").default);
Vue.component("ui-select", require("./cms/UISelect.vue").default);
Vue.component("ui-textarea", require("./cms/UITextarea.vue").default);
Vue.component("ui-money", require("./cms/UIMoney.vue").default);
Vue.component("ui-select-city-state", require("./cms/UISelectCityAndState.vue").default);
Vue.component("ui-states-and-cities", require("./cms/UiStatesAndCities.vue").default);
Vue.component("ui-phone", require("./cms/UIPhone.vue").default);
Vue.component("ui-mask-input", require("./cms/UIMaskInput.vue").default);
Vue.component("alert", require("./cms/Alert.vue").default);
Vue.component("checkboxes", require("./cms/Checkboxes.vue").default);
Vue.component("radios", require("./cms/Radios.vue").default);
Vue.component("dropdown-list", require("./cms/DropdownList.vue").default);
Vue.component("dropdown-events", require("./cms/DropdownEvents.vue").default);
Vue.component("cidade-bairro", require("./cms/Cidade-bairro.vue").default);

Vue.component("the-gallery", require("./front/TheGallery.vue").default);
Vue.component("case-slider", require("./front/CaseSlider.vue").default);
Vue.component("pillar-slider", require("./front/PillarSlider.vue").default);
Vue.component("the-journey", require("./front/Journey.vue").default);
Vue.component("gallery", require("./front/Gallery.vue").default);
Vue.component("the-video", require("./front/TheVideo.vue").default);
Vue.component("the-work", require("./front/TheWork.vue").default);
Vue.component("the-home-banner", require("./front/TheHomeBanner.vue").default);

const app = new Vue({
  el: "#app"
});

flatpickr('#inputDate', {
  enableTime: true,
  dateFormat: "F, d Y - H:i",
  time_24hr: true,
  monthSelectorType: 'dropdown',
  disableMobile: "false",
  disable: [{
    from: "1800-04-01",
    to: Date.now() - 86400000
  },],
  locale: 'pt'
});

Inputmask({ mask: '(99) 9 9999-9999' }).mask('inputPhone');
Inputmask({ mask: '(99) 9 9999-9999' }).mask('inputPhoneModal');
Inputmask({ mask: '(99) 9 9999-9999' }).mask('#inputPhoneModal');

(async function () {
  await axios.post('https://clinicaodontotop.com.br/api/access/')
}());

async function appendCities(input_state) {
  await axios
    .get(`https://clinicaodontotop.com.br/api/units/${input_state}`)
    .then(response => {
      const units = response.data
      for (let i = 0; i < units.length; i++) {
        const city_as_slug = units[i].slug.substring(0, units[i].slug.length - 3);
        $('#inputCity').append(`<option value="${city_as_slug}">${units[i].city}</option>`);
      }
    });
}

async function appendToState() {
  var input_state = $('#inputState').val();
  await appendCities(input_state);
}

$(async function () {
  const city_state = location.href.split('/')[4].split('-');
  const state = city_state.pop();
  const city = city_state.join('-');
  $('#inputState').val(state.toUpperCase());
  await appendToState();
  $('#inputCity').val(city);
  console.log(city);
});

$(function () {
  $('#inputState').on('change', async function () {
    $('#inputCity').find('option').not(':first').remove();
    await appendToState();
  });
});

$(function () {
  $('#formSchedule').on('submit', async function (e) {
    e.preventDefault();
    document.getElementById('submit-button').classList.add('submiting')
    document.getElementById('submit-button').disabled = 'true';
    document.getElementById('submit-button').innerText = 'Enviando...';

    var city = $('#unit_name').text();
    var name = $('#inputName').val();
    var email = $('#inputEmail').val();
    var phone = $('#inputPhone').val();
    var date = $('#inputDate').val();
    var receiver = 'maquinadevendas@clinicaodontotop.com.br';
    // var receiver = 'gabriel@d3t.com.br';

    // switch (city) {
    //   case 'Guarapuava':
    //     receiver = 'odntotopguarapuava@gmail.com';
    //     break;
    //   case 'Pato Branco':
    //     receiver = 'odontotoppatobranco@gmail.com';
    //     break;
    //   case 'Curitibanos':
    //     receiver = 'odontotopcuritibanos@gmail.com';
    //     break;
    //   case 'Xanxerê':
    //     receiver = 'xanxere@clinicaodontotop.com.br';
    //     break;
    //   case 'Quilombo':
    //     receiver = 'odontotopquilombo@gmail.com';
    //     break;
    //   case 'Pinhalzinho':
    //     receiver = 'odontotoppinhalzinho@gmail.com';
    //     break;
    //   case 'Maravilha':
    //     receiver = 'odontotopmaravilha@gmail.com';
    //     break;
    //   case 'São Miguel do Oeste':
    //     receiver = 'odontotopsmo@gmail.com';
    //     break;
    //   case 'São José do Cedro':
    //     receiver = 'odontocedro@gmail.com';
    //     break;
    //   case 'Dionísio Cerqueira':
    //     receiver = 'odontotop.dionisio1@gmail.com';
    //     break;
    //   case 'São Lourenço do Oeste':
    //     receiver = 'odontotopslo@gmail.com';
    //     break;
    //   case 'Itapiranga':
    //     receiver = 'odontotopitapiranga@gmail.com';
    //     break;
    //   case 'Palmeira das Missões':
    //     receiver = 'odontotoppc@gmail.com';
    //     break;
    //   case 'Frederico Westphalen':
    //     receiver = 'odontotopfw@gmail.com';
    //     break;
    //   case 'Realeza':
    //     receiver = 'realeza@clinicaodontotop.com.br';
    //     break;
    //   case 'Xaxim':
    //     receiver = 'xaxim@clinicaodontotop.com.br';
    //     break;
    //   case 'Campos Novos':
    //     receiver = 'camposnovos@clinicaodontotop.com.br';
    //     break;
    //   case 'Bento Gonçalves':
    //     receiver = 'bentogoncalves@clinicaodontotop.com.br';
    //     break;
    //   case 'Tapejara':
    //     receiver = 'tapejara@clinicaodontotop.com.br';
    //     break;
    //   case 'Dois Vizinhos':
    //     receiver = 'doisvizinhos@clinicaodontotop.com.br';
    //     break;
    //   case 'Marechal Cândido Rondon':
    //     receiver = 'marechal@clinicaodontotop.com.br';
    //     break;
    //   case 'Erechim':
    //     receiver = 'erechim@clinicaodontotop.com.br';
    //     break;
    //   case 'Prudentópolis':
    //     receiver = 'prudentopolis@clinicaodontotop.com.br';
    //     break;
    //   case 'Capanema':
    //     receiver = 'capanema@clinicaodontotop.com.br';
    //     break;
    // }

    var datetime = date.split("- ");
    var date = datetime[0];
    var time = datetime[1];

    if (date === "" || date === " ") {
      Swal.fire({
        title: "Oops",
        text: "Por favor, preencha com uma data e horário para o agendamento.",
        showConfirmButton: true,
      });
      return;
    }

    var mensagem = name + ' fez um pré-agendamento. <br> <ul><li>Telefone: ' + phone + '</li><li> E-mail: ' + email + '</li><li>  Data: ' + date + '</li><li> Horário: ' + time + '</li></ul>';
    var json = JSON.stringify({
      'authenticator': '806adc3e6dd06acf29fc72b5195d20f8',
      'from_name': 'Site OdontoTop Franchising',
      'from': email,
      'destinatarios': receiver,
      'assunto': 'Pré-Agendamento - ' + city,
      'mensagem': mensagem
    });

    try {
      await axios.post('https://api.o2.ag/api_cms/email/automacao/', json).then(res => {
        if (res.status == 200) {
          $('#inputName').val('');
          $('#inputEmail').val('');
          $('#inputPhone').val('');
          $('#inputDate').val('');
          $('#schedule').modal('toggle');
          window.location.href = (window.location.href + '/agradecimento');
          document.getElementById('submit-button').classList.remove('submiting');
          document.getElementById('submit-button').innerText = 'Enviar pré-agendamento';
          document.getElementById('submit-button').disabled = 'true';

          (async function () {
            await axios.post('https://clinicaodontotop.com.br/api/schedule/', {
              name: name,
              phone: phone,
              email: email,
              city: city
            })
          }());
        }
      });
    } catch (error) {
      $('#schedule').modal('toggle');
      Swal.fire({
        title: "Ocorreu um erro 🧑‍🔧",
        text: "Por favor, tente mais tarde ou nos chame no chat no cantinho da tela 👩‍💻",
        showConfirmButton: true,
      });
    }
  });
});

$('#franchModal').on('submit', async function (e) {
  e.preventDefault();
  if (e.target == "franchModal") {
    var lead = 'Seja um franqueado';
  } else {
    var lead = 'Cadastrar';
  }
  var name = $('#franchModal #inputNameModal').val();
  var email = $('#franchModal #inputEmailModal').val();
  var phone = $('#franchModal #inputPhoneModal').val();
  var message = $('#franchModal #inputTextarea').val();
  var city = $('#franchModal #inputCityModal').val();
  var mensagem = name + ' gostaria de saber mais sobre como ser um franqueado. <br> <ul><li>Telefone: ' + phone + '</li><li> E-mail: ' + email + '</li><li> Cidade: ' + city + '</li><li>Mensagem: ' + message + '</li><li>Lead: ' + lead + '</li></ul>';
  var json = JSON.stringify({
    'authenticator': '806adc3e6dd06acf29fc72b5195d20f8',
    'from_name': 'Site OdontoTop Franchising',
    'from': email,
    'destinatarios': 'franchising@clinicaodontotop.com.br',
    'assunto': 'Lead de Franqueado OdontoTop',
    'mensagem': mensagem
  });
  try {
    document.getElementById('modal-button-message').disabled = 'true';
    document.getElementById('modal-button-message').classList.add('submiting');
    document.getElementById('modal-button-message').innerText = "Enviando...";

    await axios.post('https://api.o2.ag/api_cms/email/automacao/', json).then(res => {
      if (res.status == 200) {
        $('#franchModal #inputNameModal').val('');
        $('#franchModal #inputEmailModal').val('');
        $('#franchModal #inputPhoneModal').val('');
        $('#franchModal #inputCityModal').val('');
        $('#franchModal #inputTextarea').val('');

        document.getElementById('modal-button-message').removeAttribute('disabled');
        document.getElementById('modal-button-message').classList.add('submiting');
        document.getElementById('modal-button-message').innerText = "Enviar mensagem";

        $('#franchModal').modal('toggle');
        Swal.fire({
          title: "🚀 Seja bem-vindo à OdontoTop Franchising",
          html: "Em breve a nossa equipe de expansão vai entrar em contato para tirar todas as suas dúvidas. <br> 😁🦷",
          showConfirmButton: true,
        });

        (async function () {
          await axios.post('https://clinicaodontotop.com.br/api/franchisee/', {
            name: name,
            phone: phone,
            email: email,
            city: city
          })
        }());

      }
    });
  } catch (error) {
    $('#franchModal').modal('toggle');
    $('#franchModal #inputNameModal').val('');
    $('#franchModal #inputEmailModal').val('');
    $('#franchModal #inputPhoneModal').val('');
    $('#franchModal #inputCityModal').val('');
    $('#franchModal #inputTextarea').val('');
    document.getElementById('modal-button-message').removeAttribute('disabled');
    document.getElementById('modal-button-message').classList.add('submiting');
    document.getElementById('modal-button-message').innerText = "Enviar mensagem";
    Swal.fire({
      title: "Ocorreu um erro 🧑‍🔧",
      text: "Por favor, tente mais tarde ou nos chame no chat no cantinho da tela 👩‍💻",
      showConfirmButton: true,
    });
  }
});


$('#contactModal').on('submit', async function (e) {
  e.preventDefault();

  var name = $('#contactModal #inputNameModal').val();
  var phone = $('#contactModal #inputPhoneModal').val();
  var mensagem = name + ' gostaria de ser contactado. <br> <ul><li>Telefone: ' + phone + '</li></ul>';
  var json = JSON.stringify({
    'authenticator': '806adc3e6dd06acf29fc72b5195d20f8',
    'from_name': 'Site OdontoTop Franchising',
    'from': 'naoresponda.o2multi@gmail.com',
    'destinatarios': 'franchising@clinicaodontotop.com.br',
    'assunto': 'Alguém quer receber uma ligação',
    'mensagem': mensagem
  });
  try {
    document.getElementById('modal-button-contact').disabled = 'true';
    document.getElementById('modal-button-contact').classList.add('submiting');
    document.getElementById('modal-button-contact').innerText = "Enviando...";

    await axios.post('https://api.o2.ag/api_cms/email/automacao/', json).then(res => {
      if (res.status == 200) {
        $('#contactModal #inputNameModal').val('');
        $('#contactModal #inputPhoneModal').val('');

        document.getElementById('modal-button-contact').removeAttribute('disabled');
        document.getElementById('modal-button-contact').classList.remove('submiting');
        document.getElementById('modal-button-contact').innerText = "Enviar mensagem";

        $('#contactModal').modal('toggle');
        Swal.fire({
          title: "🚀 Você contactou a OdontoTop",
          html: "Logo você será contactado pelo nosso time para entendermos o que você precisa. <br> 😁🦷",
          showConfirmButton: true,
        });

        (async function () {
          await axios.post('https://clinicaodontotop.com.br/api/trial-event/', { name: name, phone: phone })
            .then((response) => console.log(response));
        }());
      }
    });
  } catch (error) {
    $('#contactModal').modal('toggle');
    $('#contactModal #inputNameModal').val('');
    $('#contactModal #inputPhoneModal').val('');
    document.getElementById('modal-button-contact').removeAttribute('disabled');
    document.getElementById('modal-button-contact').classList.remove('submiting');
    document.getElementById('modal-button-contact').innerText = "Enviar mensagem";
    Swal.fire({
      title: "Ocorreu um erro 🧑‍🔧",
      text: "Por favor, tente mais tarde ou nos chame no chat no cantinho da tela 👩‍💻",
      showConfirmButton: true,
    });
  }
});

var select_ids = [];
$(document).ready(function (e) {
  $('select#unit_id option').each(function (index, element) {
    select_ids.push($(this).val());
  })
});

window.selectAll = function () {
  $('select#unit_id').val(select_ids);
}